import { ENGINEER_ROLE_ID } from './constants';

export const DEFAULT_TEAM_MEMBER_TABS = [
  'Details',
  'Equipment',
  'Spares',
  'Production',
  'Team',
  'Reporting Email',
  'Log',
  'Spacer Log',
  'ITP',
  'PQT',
  'Billing',
  'DSR',
  'Communications',
  'Material Consumption',
  'Consumables',
  'DPR',
  'Audit Trail',
];

export const DEFAULT_TAB_PERMISSIONS = {
  Details: { read: true, write: true },
  Equipment: { read: true, write: true },
  Spares: { read: true, write: true },
  Production: { read: true, write: true },
  /** @deprecated legacy tab name from API */
  Fabrication: { read: true, write: true },
  Team: { read: true, write: true },
  'Reporting Email': { read: true, write: true },
  Log: { read: true, write: true },
  'Spacer Log': { read: true, write: true },
  ITP: { read: true, write: true },
  Billing: { read: true, write: true },
  DSR: { read: true, write: true },
  Communications: { read: true, write: true },
  PQT: { read: true, write: true },
  'Material Consumption': { read: true, write: true },
  Consumables: { read: true, write: true },
  DPR: { read: true, write: true },
  'Audit Trail': { read: true, write: false },
};

export const createDefaultTeamMember = (userData) => {
  const { cognitoUserId, firstName, lastName, email } = userData;

  return {
    cognitoUserId,
    firstName,
    lastName,
    email,
    roleId: ENGINEER_ROLE_ID,
    isNonCognitoUser: false,
    accessToDsr: false,
    accessToTbt: false,
    isGuestUser: false,
    isNormalUser: true,
    selectedTabs: DEFAULT_TEAM_MEMBER_TABS,
    tabPermissions: DEFAULT_TAB_PERMISSIONS,
  };
};
